import { useGenericContext } from "../../hooks";
import { PermissionsContext } from "./PermissionsContext";

export const usePermissions = () => useGenericContext(PermissionsContext);
